import type { AttributeValue } from '../model/types';

/**
 * Best-effort human-readable rendering of a typed `AttributeValue` outside its dedicated editor
 * row — used for read-only contexts (orphaned/legacy value lists, variant axis-value chips).
 * Prefers the server-resolved `label` (SELECT/MULTISELECT option label(s), already localized);
 * falls back to `amount`/`unit` for MEASUREMENT, then the raw `value` (joining an array).
 */
export function formatAttributeValueDisplay(value: AttributeValue): string {
  if (value.label) return value.label;
  if (value.type === 'MEASUREMENT' && value.amount != null) {
    return `${value.amount}${value.unit ? ` ${value.unit}` : ''}`;
  }
  if (Array.isArray(value.value)) return value.value.join(', ');
  if (value.value === undefined || value.value === null || value.value === '') return '—';
  return String(value.value);
}
